import { render, staticRenderFns } from "./orderQuotationAdd.vue?vue&type=template&id=2ec2e25e&scoped=true"
import script from "./orderQuotationAdd.vue?vue&type=script&lang=js"
export * from "./orderQuotationAdd.vue?vue&type=script&lang=js"
import style0 from "./orderQuotationAdd.vue?vue&type=style&index=0&id=2ec2e25e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec2e25e",
  null
  
)

export default component.exports